module.exports = __webpack_public_path__ + "8edf865dafa832d1e66d1508b0fdb668.svg";